<template>
<div class="page_pay">
    <!-- 绑微信提醒 -->
    <div class="wechat_tips" v-if="!bindWX" @click="bandwechat" style="padding-left:.53rem">
        <div class="tips_left">请绑定微信</div>
        <div class="tips_right">
            <img :src="publicPath+'statics/images/weixin-2.png'" alt="" class="icon_wechat">
            <img :src="publicPath+'statics/images/icon_right_grey.png'" alt="" class="icon_right">
        </div>
    </div>
    <!-- 订单信息 -->
    <div class="order">
        <div class="order_tips">订单已提交</div>
        <div class="order_number">支付订单号：{{ orderId }}</div>
    </div>
	<!-- iyiqi支付方式 -->
	<div class="payList" v-if="iyiqiUser == 1 && from!='number'">
        <van-cell class="item">
			<template #title>
				<img :src="publicPath + 'statics/images/shop/icon_jifen.png'" alt="" class="tu">
				<span class="title">i一起积分</span>
			</template>
			<template #right-icon>
				<van-checkbox v-model="iyiqiPay">
					<template #icon="props">
						<img class="img-icon" :src="props.checked ? activeIcon_plat : inactiveIcon_plat">
					</template>
				</van-checkbox>
			</template>
		</van-cell>
    </div>
    <!-- 支付方式 -->
    <div class="payList">
        <van-checkbox-group v-model="checkedPay">
            <van-cell-group>
                <van-cell class="item" v-for="(item,index) in payMent" :key="index" @click="FunCheckPay(item)">
                    <template #title>
                        <img :src="item.icon" alt="" class="tu">
                        <span class="title">{{item.name}}</span>
                    </template>
                    <template #right-icon>
                        <van-checkbox :name="item.id" :disabled="item.status ? false : true">
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                            </template>
                        </van-checkbox>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-checkbox-group>
    </div>
    <!-- 另一类支付方式 -->
	<!-- && pay_status != 1 -->
    <div class="payList" v-if="sorce != 1 " @click="clickWrap">
        <van-checkbox-group v-model="checkedPay_plat" @change="FunCheckPayPlat">
            <van-cell-group>
                <div v-for="(item,index) in payMent_plat" :key="index">
                    <van-cell class="item">
                        <template #title>
                            <img :src="item.icon" alt="" class="tu">
                            <span class="title">{{item.name}}{{item.id==5?'（可用余额：￥'+useraccount.user_money+'）': item.id == 7? '（可用积分：'+ park_point +'）': item.id == 9 ? '（可用积分：'+useraccount.new_points+'）' : ''}}</span>
                        </template>
                        <template #right-icon>
                            <van-checkbox :name="item.id" :disabled="item.status ? false : true">
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? activeIcon_plat : inactiveIcon_plat">
                                </template>
                            </van-checkbox>
                        </template>
                    </van-cell>
					<!-- 平台充值卡 -->
                    <van-checkbox-group v-if="item.id==6&&checkedPay_plat.indexOf(6)!=-1" v-model="checkedCardPay_plat" @change="FunCheckCardPayPlat">
                        <van-cell class="item" v-for="card in cardShowList" :key="card.id">
                            <template #title>
                                <!-- <img :src="item.icon" alt="" class="tu"> -->
                                <span class="title">{{card.name}}</span>
                            </template>
                            <template #right-icon>
                                <van-checkbox :name="card.id" :disabled="card.status ? false : true">
                                    <template #icon="props">
                                        <img class="img-icon" :src="props.checked ? activeIcon_plat : inactiveIcon_plat">
                                    </template>
                                </van-checkbox>
                            </template>
                        </van-cell>
                    </van-checkbox-group>
					<!-- 园区充值卡 -->
					<van-checkbox-group v-if="item.id==8&&checkedPay_plat.indexOf(8)!=-1" v-model="checkedCardPay_plat" @change="FunCheckCardPayPlat">
                        <van-cell class="item" v-for="card in parkCardList" :key="card.id">
                            <template #title>
                                <!-- <img :src="item.icon" alt="" class="tu"> -->
                                <span class="title">{{card.name}}</span>
                            </template>
                            <template #right-icon>
                                <van-checkbox :name="card.id" :disabled="card.status ? false : true">
                                    <template #icon="props">
                                        <img class="img-icon" :src="props.checked ? activeIcon_plat : inactiveIcon_plat">
                                    </template>
                                </van-checkbox>
                            </template>
                        </van-cell>
                    </van-checkbox-group>
                </div>
            </van-cell-group>
        </van-checkbox-group>
		<!-- 填写积分 -->
		<div class="item" v-if="selectPayPlatId && selectPayPlatId.indexOf(7)!=-1">
			<van-field v-model="jifen" type="digit" label="积分" placeholder="请输入积分" :border="false" @input="jifenFun" />
			<div class="jifentips">{{'该订单所需最高积分为' + needJifen}}</div>
		</div>
    </div>
    <!-- 支付 -->
    <div class="action">
        <div class="pay" @click="tijiao">立即支付¥{{ price }}</div>
    </div>
	<!-- 未支付时,离开页面给提醒 -->
	<van-dialog v-model="showPayTips" title="是否取消支付" message="您的订单在2小时内未支付将被取消，请尽快完成支付。" show-cancel-button cancel-button-text="继续支付" confirm-button-text="确认离开" @cancel="cancelTips" @confirm="confirmTips">
	</van-dialog>
	<!-- loading -->
	<van-overlay :show="showloading">
		<van-loading class="soltloading" />
	</van-overlay>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
import { Dialog } from 'vant';
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            orderId: null,
            from: null,
            price: null,
            isPlatprice: 0,
            token: null,
            useraccount: {},
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            selectPayItem: null,
            selectPayPlatId: null,
            payMent: [{
                    id: 1,
                    name: '微信支付',
                    pay: 'weixin',
                    icon: process.env.BASE_URL + 'statics/images/shop/icon_wechat.png',
                    status: 1
                },
                // {
                //     id: 2,
                // 	name: '支付宝支付',
                // 	icon: process.env.BASE_URL + 'statics/images/shop/icon_alipay.png',
                // 	status: 1
                // },
                // {
                //     id: 3,
                // 	name: '银联支付',
                // 	icon: process.env.BASE_URL + 'statics/images/shop/icon_unionpay.png',
                // 	status: 0
                // },
                // {
                //     id: 4,
                // 	name: '银行储蓄卡',
                // 	icon: process.env.BASE_URL + 'statics/images/shop/icon_bankpay.png',
                // 	status: 0
                // }
            ],
            checkedPay: [],
            activeIcon_plat: process.env.BASE_URL + 'statics/images/active_square.png',
            inactiveIcon_plat: process.env.BASE_URL + 'statics/images/inactive_square.png',
            checkedPay_plat: [], // 复选框组，初始值为数组，支付方式
            payMent_plat: [
				// {
                //     id: 5,
                //     name: '余额',
                //     icon: process.env.BASE_URL + 'statics/images/shop/icon_balance.png',
                //     status: 1
                // },
                // {
                //     id: 6,
                //     name: '充值卡',
                //     icon: process.env.BASE_URL + 'statics/images/shop/icon_charge.png',
                //     status: 1
                // },
                // {
                // 	id: 7,
                // 	name: '积分换购',
                // 	icon: process.env.BASE_URL + 'statics/images/shop/icon_jifen.png',
                // 	status: 0
                // }
            ],
            cardList: [], //充值卡列表
            cardShowList: [], //充值卡复选列表
            checkedCardPay_plat: [], // 复选框组，初始值为数组，充值卡
            selectPayCardPlatId: null,
            isClient: false,
			bindWX: false, // 判断用户是否绑定微信,用于提醒去绑微信才可微信支付
			sorce: this.$route.query.sorce, // 0商城 1云支付(云支付只支持微信这一个付款方式)
			park_point: this.$route.query.park_point, // 所在园区积分
			duihuan_money: this.$route.query.duihuan_money, // 积分兑换比例
			jifen: null, // 用户输入的积分
			needJifen: null,
            pay_status: this.$route.query.pay_status,
			type: this.$route.query.type,
			dingzhi_status: this.$route.query.dingzhi_status, // 1 待付定金, 2 待付尾款
			showPayTips: false, // 未支付,离开页面时的提示层
			is_pay: false, // 是否支付
			parkCardList: null, // 园区充值卡
			park_uuid: this.$route.query.park_uuid,
            is_chargecard: this.$route.query.is_chargecard,
			showloading: false,
			iyiqiUser: null, // iyiqi 积分支付相关
			iyiqiToken: null,
			iyiqiPhone: null,
			iyiqiPay: false,
			thirdJifenBili: null, // 第三方积分兑换比例
        };
	},
	beforeRouteLeave(to,from,next){
        let that = this
		if(to.name == 'set-account' || to.name == 'pay-success'){
			next()
		}else{
            if(!this.is_pay){
                Dialog.confirm({
                title: '是否取消支付',
                message: '您的订单在2小时内未支付将被取消，请尽快完成支付。',
                showConfirmButton:true,
                confirmButtonText: '确认离开',
                cancelButtonText:'继续支付',
                showCancelButton: true,
                closeOnPopstate: false,
                // theme: 'round-button',
                }).then(() => {
                    console.log('确认离开')
                    that.is_pay = true
                    that.$router.back(-1)
                }).catch(()=>{
                    console.log('继续支付')
                });
                next(false)
            } else {
                next()
            }
		}
    },
    components: {
        // PageSearch
    },
    created: function () {
		console.log('jifen',this.jifen)
		this.thirdJifenBili = this.$route.query.thirdJifenBili;
        this.orderId = this.$route.query.orderId;
        this.price = this.$route.query.price;
        this.from = this.$route.query.from;
		// 0b2c  1b2b. 2园区
        this.isPlatprice = this.$route.query.isPlatprice;
        if (this.isPlatprice == null || this.isPlatprice == undefined || this.isPlatprice == '') {
            this.isPlatprice = 0
        }
        if (this.isPlatprice == 1) {
            this.payMent_plat = [{
                    id: 5,
                    name: '余额',
                    icon: process.env.BASE_URL + 'statics/images/shop/icon_balance.png',
                    status: 1
                },
                // {
                //     id: 6,
                //     name: '充值卡',
                //     icon: process.env.BASE_URL + 'statics/images/shop/icon_charge.png',
                //     status: 1
                // },
            ]
        }
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '支付'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            console.log('sdjy://member/memberInfo')
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getUserData()
                    this.getChargeCard()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getUserData();
			this.getChargeCard()
			// 获取园区充值卡列表
			// if(this.isPlatprice == 2){
			// 	this.getParkCard()
			// };
			// iyiqi用户
			this.verfyiyiqi();
			
        }
    },
	watch: {
		'iyiqiPay': function(val){
			// 一经选中iyiqi的积分支付,其余支付方式都不可选
			if(val){
				this.checkedCardPay_plat = [];
				this.checkedPay_plat = [];
				this.checkedPay = [];
				for(let i in this.payMent){
					this.payMent[i].status = 0;
				};
				for(let j in this.payMent_plat){
					this.payMent_plat[j].status = 0;
				};
			}else{
				this.payMent = [{
					id: 1,
                    name: '微信支付',
                    pay: 'weixin',
                    icon: process.env.BASE_URL + 'statics/images/shop/icon_wechat.png',
                    status: 1
				}]
				this.setPaytype();
			};
			// console.log('payMent',this.payMent);
			// console.log('payMent_plat',this.payMent_plat);
		}
	},
    methods: {
		clickWrap(){
			if(this.iyiqiPay){
				this.$toast('积分支付,不可与其他方式同时使用');
			};
		},
		/**
		 * @name: 验证是否为iyiqi用户
		 * @return {*}
		 * @desc: 
		 */		
		verfyiyiqi(){
			let params = {
				token: this.token
			};
			this.$api.my.isiyiqiuser(params).then(res=>{
				if(res.code == 200){
					this.iyiqiUser = res.result.is_user;
					// this.iyiqiUser = 1;
					this.iyiqiToken = res.result.iyiqi_token;
					this.iyiqiPhone = res.result.phone;
				}
			})
		},
        getChargeCard() {
            var params = {
                token: this.token,
                tag: 1,
                page: 1,
                size: 100
			}
			if(this.park_uuid){
				params.park_uuid = this.park_uuid
			}
            this.$api.my.cardList(params).then(res => {
                if (res.code == 200) {
                    this.cardList = res.result.list // 平台充值卡
                    var newList = []
                    for (let i = 0; i < this.cardList.length; i++) {
                        const card = this.cardList[i];
                        if (card.reset_money > 0) {
                            var newCard = {
                                id: card.id,
                                name: '卡号：' + card.number + ' 余额：￥' + card.reset_money,
                                status: card.reset_money > 0 ? 1 : 0,
								reset_money: card.reset_money
                            }
                            newList.push(newCard)
                        }
                    }
					this.cardShowList = newList
					// 园区充值卡
					var parkCards = res.result.park_charge_card
					var parkCardList = []
					for(var j = 0; j < parkCards.length; j++){
						var item = parkCards[j]
						if(item.reset_money > 0){
							var itemCard = {
								id: item.id,
								name: '卡号：' + item.number + ' 余额：￥' + item.reset_money,
								status: item.reset_money > 0 ? 1 : 0,
								reset_money: item.reset_money
							}
							parkCardList.push(itemCard)
						}
					}
					this.parkCardList = parkCardList
                    this.setPaytype()
                } else {
                    this.$toast(res.message)
                }
            })
		},
        // 获取列表
        getUserData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    this.useraccount = res.result.info.useraccount
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        if (res.result.info.users.app_openid && res.result.info.users.app_openid != undefined && res.result.info.users.app_openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    } else {
                        if (res.result.info.users.openid && res.result.info.users.openid != undefined && res.result.info.users.openid != '') {
                            this.bindWX = true
                        } else {
                            this.bindWX = false
                        }
                    }
                    
                    this.setPaytype()
                }
            })
        },
        //设置支付方式
        setPaytype() {
            var pay = []
            //余额大于0、
            console.log('this.useraccount:',this.useraccount)
            console.log('this.isPlatprice:',this.isPlatprice)
            if (this.useraccount && this.useraccount.user_money > 0 && this.isPlatprice != 2 && this.isPlatprice != 3) {
                pay.push({
                    id: 5,
                    name: '余额',
                    icon: process.env.BASE_URL + 'statics/images/shop/icon_balance.png',
                    status: 1
                })
            }
            if (this.cardShowList && this.cardShowList.length > 0 && (this.isPlatprice == 1 || (this.is_chargecard == 1 && !this.park_uuid))) {
                pay.push({
                    id: 6,
                    name: '充值卡',
                    icon: process.env.BASE_URL + 'statics/images/shop/icon_charge.png',
                    status: 1
                })
			}
			// 是园区订单 并 在该园区有积分 且兑换比例不为0
			if (this.isPlatprice == 2 && this.park_point > 0 && this.duihuan_money != 0) {
				pay.push({
                	id: 7,
                	name: '园区积分',
                	icon: process.env.BASE_URL + 'statics/images/shop/icon_jifen.png',
                	status: 1
                })
			}
			if((this.isPlatprice == 2 || this.park_uuid) && this.parkCardList && this.parkCardList.length != 0 && this.is_chargecard>0){
				pay.push({
                	id: 8,
                	name: '园区充值卡',
                	icon: process.env.BASE_URL + 'statics/images/shop/icon_charge.png',
                	status: 1
                })
			};
			// 对接第三方积分
			if(this.useraccount && this.useraccount.new_points > 0 && this.type != 'made'){
				pay.push({
                	id: 9,
                	name: '平台积分',
                	icon: process.env.BASE_URL + 'statics/images/shop/icon_jifen.png',
                	status: 1
                })
			}
            this.payMent_plat = pay
        },
        //提交支付
        tijiao() {
            let that = this;
            // return
			if(this.iyiqiUser == 1){
				if(!this.iyiqiPay && this.checkedPay.length == 0 && this.checkedPay_plat.length == 0){
					this.$toast('请选择支付方式');
					return;
				}
			}else{
				if(this.checkedPay.length == 0 && this.checkedPay_plat.length == 0){
					this.$toast('请选择支付方式');
					return;
				}
			}
			if(this.iyiqiPay){
				let backToUrl = this.type == 'made' ? this.$publicData.domain+'/order/dingzhi/index?status=1' : this.$publicData.domain+'/shop/order?status=2';
				let backType = this.type == 'made' ? 3 : 1; // 1商城 2约看 3定制
				let parames = {
					token: this.iyiqiToken,
					phone: this.iyiqiPhone,
					businessNum: this.orderId,
					payMoney: this.price,
					sourceType: 4, // 0:uniapp 1:微信小程序  2:ios   3:Android ;else 其他是H5
					backToUrl: backToUrl,
					backType: backType,
				};
				let url = this.$publicData.iyiqiUrl+'?parames='+encodeURIComponent(JSON.stringify(parames));
				window.open(url,'_self');
			}else{
				this.showloading = true;
				let used_money = 0
				let cardId = null // 平台充值卡
				let parkCardId = null // 园区充值卡
				// console.log('this.checkedPay_plat', this.checkedPay_plat);
				if(this.checkedPay_plat.indexOf(6) != -1){
					// 平台充值卡付
					cardId = this.selectPayCardPlatId;
					if (cardId == null || cardId == undefined || cardId == '') {
						this.$toast('请选择充值卡')
						this.showloading = false
						return
					}
				};
				if(this.checkedPay_plat.indexOf(7) != -1){
					// 积分付
					if(this.jifen == null){
						this.$toast('请输入积分')
						this.showloading = false
						return
					};
				};
				if(this.checkedPay_plat.indexOf(8) != -1){
					// 园区充值卡付
					parkCardId = this.selectPayCardPlatId
					if (parkCardId == null || parkCardId == undefined || parkCardId == '') {
						this.$toast('请选择园区充值卡')
						this.showloading = false
						return
					};
				};
				// 留着,测试完再删
				// if (this.checkedPay_plat.length) {
				// 	for (let i = 0; i < this.checkedPay_plat.length; i++) {
				// 		const pay = this.checkedPay_plat[i];
				// 		if (pay == 5) {
				// 			used_money = this.price
				// 		} else if (pay == 6) {
				// 			cardId = this.selectPayCardPlatId
				// 			if (cardId == null || cardId == undefined || cardId == '') {
				// 				this.$toast('请选择充值卡')
				// 				this.showloading = false
				// 				return
				// 			}
				// 		} else if(pay == 7){
				// 			// 积分支付
				// 			if(this.jifen == null){
				// 				this.$toast('请输入积分')
				// 				this.showloading = false
				// 				return
				// 			}
				// 			if(this.jifen < this.needJifen){
				// 				// 当输入积分不足以支付订单时,判断是否勾选微信支付
				// 				if(!this.selectPayItem){
				// 					this.$toast('请选择支付方式')
				// 					this.showloading = false
				// 					return
				// 				}
				// 			}
				// 		}else if(pay == 8){
				// 			// 园区充值卡
				// 			parkCardId = this.selectPayCardPlatId
				// 			if (parkCardId == null || parkCardId == undefined || parkCardId == '') {
				// 				this.$toast('请选择园区充值卡')
				// 				this.showloading = false
				// 				return
				// 			}
				// 		}
				// 	}
				// };
				let params = {
					token: this.token,
					pay_order_num: this.orderId,
					is_platprice: this.isPlatprice,
				};
				// 判断点选的支付方式，是否够支付此笔订单
				let prePrice = 0;
				let yueMoney = 0;
				if(this.checkedPay_plat.indexOf(5) != -1){
					// 余额付
					used_money = this.price;
					if( parseFloat(used_money) < parseFloat(this.useraccount.user_money) ){
						yueMoney = used_money;
					}else{
						yueMoney = this.useraccount.user_money;
					};
					params.used_money = yueMoney;
					prePrice += parseFloat(yueMoney);
				};
				// 平台充值卡
				if (cardId != null && cardId != undefined && cardId != '') {
					params.card_id = cardId;
					for(let z in this.cardShowList){
						if(cardId.indexOf(this.cardShowList[z].id) != -1 ){
							prePrice += parseFloat(this.cardShowList[z].reset_money);
						}
					}
				};
				console.log('prePrice',prePrice)
				//  园区充值卡
				if (parkCardId != null && parkCardId != undefined && parkCardId != '') {
					params.park_charge_card_id = parkCardId;
					for(let v in this.parkCardList){
						if(parkCardId.indexOf(this.parkCardList[v].id) != -1){
							prePrice += parseFloat(this.parkCardList[v].reset_money);
						}
					}
				};
				// 积分支付
				if(this.checkedPay_plat.indexOf(7) != -1){
					params.duihuan_money = this.duihuan_money;
					params.park_score = this.jifen;
					prePrice += parseFloat(this.duihuan_money);
				};
				// 平台积分支付(对接第三方的积分转换成平台的积分)
				if(this.checkedPay_plat.indexOf(9) != -1){
					params.new_points = 1;
					let thirdPoint = this.useraccount.new_points;
					let thirdPointMoney = Math.floor(thirdPoint / this.thirdJifenBili);
					prePrice += thirdPointMoney;
				};
				console.log('prePrice',prePrice)
				if(this.checkedPay.indexOf(1) == -1){
					// 如果未选微信，且钱不够付，需要给提示
					if(prePrice < this.price){
						this.$toast('请选择其它支付方式');
						this.showloading = false
						return;
					}
				}else{
					params.pay = 'weixin'
				};


				// 先不删,测完再说
				// if(this.checkedPay_plat.length){
				// 	// 余额支付
				// 	if(this.checkedPay_plat.indexOf(5) != -1){
				// 		if (used_money == 0 && !this.checkedPay.length && cardId == null) {
				// 			this.$toast('请选择支付方式')
				// 			this.showloading = false
				// 			return
				// 		};
				// 		if (used_money > 0) {
				// 			// console.log('11-- used_money',used_money) // 1500.00
				// 			// console.log('22--user_money', this.useraccount.user_money) // 419.69
				// 			// console.log(parseFloat(used_money) > parseFloat(this.useraccount.user_money))
				// 			var money = 0
				// 			if (parseFloat(used_money) < parseFloat(this.useraccount.user_money)) {
				// 				money = used_money
				// 			} else {
				// 				money = this.useraccount.user_money
				// 			}
				// 			params.used_money = money
				// 		}
				// 	}
				// 	// 积分支付
				// 	if(this.checkedPay_plat.indexOf(7) != -1){
				// 		params.duihuan_money = this.duihuan_money
				// 		params.park_score = this.jifen
				// 	}
				// };
				// if (this.checkedPay.indexOf(1) != -1) {
				// 	params.pay = 'weixin'
				// };
				// // 平台充值卡
				// if (cardId != null && cardId != undefined && cardId != '') {
				// 	params.card_id = cardId
				// }
				// //  园区充值卡
				// if (parkCardId != null && parkCardId != undefined && parkCardId != '') {
				// 	params.park_charge_card_id = parkCardId
				// };
				console.log('参数====',params)
				// return
				if (this.type == 'made' ) {
					this.madePay(used_money)
					return
				}
				if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
					params.tag = 1
				};
				// return;
				this.$api.shop.goodsPay(params).then(res => {
					if (res.code == 200) {
						that.showloading = false;
						var data = res.result;
						if (data.config) {
							if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
								if (data.config == null || data.config == undefined) {
									that.$toast(data)
									return
								}
								var p = data.config
								p.url = that.$publicData.clientUrl + '/pay/success?orderId='+that.orderId
								var params = {
									'data': p
								}
								that.$bridge.callhandler('sdjy://public/wxPay', params, (data) => {
									
								})
								return
							}else{
								// 配置微信config
								wx.config({
									debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
									appId: data.config.appId, // 必填，公众号的唯一标识
									timestamp: data.config.timeStamp, // 必填，生成签名的时间戳
									nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
									signature: data.config.paySign, // 必填，签名，见附录1
									jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
								});
								// 配置失败返回
								wx.error(function (res) {
									console.log('error')
									console.log(res)
									// that.$toast("微信支付配置失败！");
								});
								wx.ready(function () {
									// 调起微信支付
									wx.chooseWXPay({
										timestamp: data.config.timeStamp,
										nonceStr: data.config.nonceStr,
										package: data.config.package,
										signType: data.config.signType,
										paySign: data.config.paySign, // 支付签名
										success: function (res) {
											console.log('success')
											console.log(res)
											// 支付成功，转到订单列表页面
											window.localStorage.removeItem('createOrder')
											if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
												var params = {
													'data': {
														'url': that.$publicData.clientUrl + '/pay/success'
													}
												}
												that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

												})
											} else {
												that.$router.push({
													path: '/pay/success',
													query: {
														orderId: that.orderId,
														from: that.from
													}
												})
											}
										},
										error: function (res) {

										},
										cancel: function (res) {

										}
									});
								});
							}
						} else {
							window.localStorage.removeItem('createOrder');
							if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
								var params = {
									'data': {
										'url': that.$publicData.clientUrl + '/pay/success'
									}
								}
								that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

								})
							} else {
								that.$router.push({
									path: '/pay/success',
									query: {
										orderId: that.orderId,
										from: that.from
									}
								})
							}
						}
					} else {
						that.$toast(res.message)
						that.showloading = false
					}
				})

			}    
        },
        /**
         * @name: 定制支付
         * @param {*} used_money
         * @return {*}
         * @desc: 
         */		
        madePay(used_money) {
            var that = this
            var params = {
                token: this.token,
                pay_order_num: this.orderId,
			}
            if (this.checkedPay.indexOf(1) != -1) {
                params.pay = 'weixin'
            } 
			var cardId = null // 平台充值卡
			var parkCardId = null // 园区充值卡
            if (this.checkedPay_plat.length) {
                for (let i = 0; i < this.checkedPay_plat.length; i++) {
                    const pay = this.checkedPay_plat[i];
                    if (pay == 5) {
                        used_money = this.price
                    } else if (pay == 6) {
                        cardId = this.selectPayCardPlatId
                        if (cardId == null || cardId == undefined || cardId == '') {
                            this.$toast('请选择充值卡')
                            this.showloading = false
                            return
                            }
                    } else if(pay == 8){
                        // 园区充值卡
                        parkCardId = this.selectPayCardPlatId
                        if (parkCardId == null || parkCardId == undefined || parkCardId == '') {
                            this.$toast('请选择园区充值卡')
                            this.showloading = false
                            return
                        }
                    }
                }
            }
            if(this.checkedPay_plat.length){
				// 余额支付
				if(this.checkedPay_plat.indexOf(5) != -1){
					if (used_money == 0 && !this.checkedPay.length && cardId == null) {
						this.$toast('请选择支付方式')
						this.showloading = false
						return
					}
                    // params.pay = 'yue'
					if (used_money > 0) {
						var money = 0
						if (parseFloat(used_money) < parseFloat(this.useraccount.user_money)) {
							money = used_money
						} else {
							money = this.useraccount.user_money
						}
						params.used_money = parseFloat(money)
					}
				}
            }
            // 平台充值卡
            if (cardId != null && cardId != undefined && cardId != '') {
                params.card_id = cardId.join(',')
			}
			//  园区充值卡
			if (parkCardId != null && parkCardId != undefined && parkCardId != '') {
                params.card_id = parkCardId.join(',')
			}
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                params.tag = 1
            }
			console.log('params',params)
            this.$api.dingzhi.topay(params).then(res => {
                if (res.code == 200) {
					that.showloading = false
                    var data = res.result;
					if(data.config){
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1){
							var p = data.config
							p.url = that.$publicData.clientUrl + '/pay/success?orderId='+that.orderId+'&type=made'+'&dingzhi_status='+that.dingzhi_status
							var params = {
								'data': p
							}
							that.$bridge.callhandler('sdjy://public/wxPay', params, (data) => {
								
							})
						}else{
							// 配置微信config
							wx.config({
								debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
								appId: data.config.appId, // 必填，公众号的唯一标识
								timestamp: data.config.timeStamp, // 必填，生成签名的时间戳
								nonceStr: data.config.nonceStr, // 必填，生成签名的随机串
								signature: data.config.paySign, // 必填，签名，见附录1
								jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
							});
							// 配置失败返回
							wx.error(function (res) {
								console.log('error')
								console.log(res)
								// that.$toast("微信支付配置失败！");
							});
							wx.ready(function () {
                            	// 调起微信支付
								wx.chooseWXPay({
									timestamp: data.config.timeStamp,
									nonceStr: data.config.nonceStr,
									package: data.config.package,
									signType: data.config.signType,
									paySign: data.config.paySign, // 支付签名
									success: function (res) {
										console.log('success')
										console.log(res)
										// 支付成功，转到订单列表页面
										window.localStorage.removeItem('createOrder')
										if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
											var params = {
												'data': {
													'url': that.$publicData.clientUrl + '/pay/success?orderId='+that.orderId+'&type=made'+'&dingzhi_status='+that.dingzhi_status
												}
											}
											that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

											})
										} else {
											that.$router.push({
												path: '/pay/success',
												query: {
													orderId: that.orderId,
													type: 'made',
													dingzhi_status: that.dingzhi_status,
													from: that.from
												}
											})
										}
									},
									error: function (res) {

									},
									cancel: function (res) {

									}
								});
							});
						}
						
					}else{
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
							var params = {
								'data': {
									'url': that.$publicData.clientUrl + '/pay/success?orderId='+that.orderId+'&type=made'+'&dingzhi_status='+that.dingzhi_status
								}
							}
							that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

							})
						} else {
							that.$router.push({
								path: '/pay/success',
								query: {
									orderId: that.orderId,
									type: 'made',
									dingzhi_status: that.dingzhi_status,
									from: that.from
								}
								
							})
						}
					}
                } else {
					that.$toast(res.message)
					that.showloading = false
                }
            })
        },
        // 选中支付方式 第三方如微信、支付宝、银行卡等‘单选’
        FunCheckPay(item) {
            if (!item.status) {
                this.$toast('暂不支持，该支付方式！');
            }
        },
        // 选中支付方式 平台余额、充值卡等 ‘可多选’
        FunCheckPayPlat() {
			console.log('checkedPay_plat',this.checkedPay_plat);
			if(this.checkedPay_plat.indexOf(7)!= -1){
				this.needJifen = Math.ceil(this.price / (this.duihuan_money * 0.01))
			};
        },
        FunCheckCardPayPlat(id) {
            this.selectPayCardPlatId = id
            console.log(id)
        },
        // 绑定微信
        bandwechat() {
			// this.showPayTips = false // 绑微信,不给未支付提醒
            this.$router.push({
                path: '/set/account'
            })
		},
		// 输入积分
		jifenFun(val){
			console.log('val',val)
			// 当输入积分 大于 所需最高积分
			if(val > this.needJifen){
				this.$toast('所需最高积分为'+ this.needJifen)
				this.jifen = this.needJifen
				return
			}else if (val > this.park_point){
				this.$toast('您的积分不足')
				this.jifen = this.park_point
			}
		},
		// 继续支付
		cancelTips(){
            console.log('cancelTips')
			this.is_pay = false
			this.showPayTips = false
		},
		// 确认离开
		confirmTips(){
            console.log('confirmTips')
			this.is_pay = true
			this.showPayTips = false
			this.$router.back(-1)
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-cell .van-field__control{
	color: #323233;
}
.jifentips{
	padding-top: .4rem;
	text-align: right;
	font-size: 0.35rem;
	color: #ccc;
}
</style>
